import {ScheduledClass} from "../ClassDefinitionProvider";


export const filterConfirmed = (schedule: ScheduledClass) => {
    return schedule.students.filter(s => s.status === "fully-paid" || s.status === "deposit-paid");
}

export const filterCandiates = (schedule: ScheduledClass) => {
    return schedule.students.filter(s => s.status === "candidate" || s.status === "tentative");
}